import "./Payment.scss";
import useResponsive from "../../../hooks/useResponsive";
import { LogoSection } from "../../../Components/LogoSection";
import { OrderSummary } from "../../../Components/OrderSummary";
import {
  Subtitle,
  Title,
  Text,
  Subheader,
} from "../../../Components/Typography";

import LogoMP from "../../../assets/logo-mp.png";
import { useContext, useEffect } from "react";
import {
  PaymentContext,
  PaymentContextProps,
} from "../../../Contexts/PaymentContext";
import { routes } from "../../../Router";
import { useNavigate, useSearchParams } from "react-router-dom";
import useDatabase from "../../../hooks/useDatabase";

import useLocalStorage from "../../../hooks/useLocalStorage";
import {
  EntitiesContext,
  EntitiesContextProps,
} from "../../../Contexts/EntitiesContext";

import { toast } from "react-toastify";
import { initMercadoPago, Wallet } from "@mercadopago/sdk-react";
import {
  AdminContext,
  AdminContextProps,
} from "../../../Contexts/AdminContext";

export const Payment = () => {
  const navigate = useNavigate();
  const { isDesktopOrLaptop } = useResponsive();
  const { loading, getCollectionByTrackingCode } = useDatabase();
  const { storageKeys, getSessionStorageItem } = useLocalStorage();

  const { preferenceResponse }: PaymentContextProps =
    useContext<any>(PaymentContext);
  const { orders, formatOrders, setSelectedOrder }: AdminContextProps = useContext<any>(AdminContext);

  const { preferenceId } = preferenceResponse;

  const { refreshEntity }: EntitiesContextProps =
    useContext<any>(EntitiesContext);

  const htmlDisclaimerText =
    'El pago se realiza a través de MercadoPago.<br/>Consultá medios de pago aceptados <a href="a">acá.</a>';

  const [searchParams] = useSearchParams();

  const api_key_mp = process.env.REACT_APP_MP_PUBLIC_KEY;

  if (api_key_mp) {
    initMercadoPago(api_key_mp, { locale: "es-AR" });
  } else {
    console.error("Mercado Pago API key is not defined");
  }

  useEffect(() => {
    refreshEntity("status");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Mercado Libre callback with payment status
  useEffect(() => {
    const mpCallback = async () => {
      const status = searchParams.get("status");

      if (status) {

        // Redirect to Order Confirmation
        if (status === "approved") {
          const trackingCode = getSessionStorageItem(storageKeys.randomId);
          const orders = await getCollectionByTrackingCode(
            "view_order",
            trackingCode ?? ""
          );

          if (orders && orders.length > 0) {
            // Set orders to trigger useEffect and redirect
            formatOrders(orders);
          } else {
            toast.error(`Error al procesar order ${trackingCode}`);  
          }
        } else {
          toast.error("Error al procesar el pago");
          navigate(routes.clientNewOrder.path);
        }
      }
    };

    mpCallback();
  }, []);

  // Get selected order to display (callback Mercado Pago)
  useEffect(() => {
    if (orders && orders.length > 0) {
      setSelectedOrder(orders[0]);
      navigate(routes.clientOrderConfirm.path);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orders]);

  const onClickNext = async () => {};

  const onClickBack = () => {
    navigate(routes.clientInfo.path);
  };

  return (
    <div className={isDesktopOrLaptop ? "payment-desktop" : "payment-mobile"}>
      <LogoSection showInstructions={false}/>

      <div className="main-column">
        <div className="top-content">
          <div className="next-steps-section">
            <div className="step"></div>

            <div className="step">
              <Subheader disabled>Paso 1</Subheader>
              <Subtitle disabled>Archivos y Opciones de Impresión</Subtitle>
            </div>

            <div className="step">
              <Subheader disabled>Paso 2</Subheader>
              <Subtitle disabled>Opciones de Envío</Subtitle>
            </div>

            <div className="step">
              <Subheader disabled>Paso 3</Subheader>
              <Subtitle disabled>Datos para retirar la orden</Subtitle>
            </div>
          </div>
          <div className="title-section">
            <Subheader>Paso 4</Subheader>
            <Title>Confirmar y pagar la orden</Title>
          </div>

          <div className="disclaimer-section">
            <div>
              <img src={LogoMP} alt="" />
            </div>
            <Text html={htmlDisclaimerText} />
          </div>
        </div>
      </div>

      <OrderSummary
        showAddressForm
        showPaymentForm
        isNextEnabled
        onClickNext={onClickNext}
        onClickBack={onClickBack}
        loadingNext={loading}
        preferenceId={preferenceId}
      />
    </div>
  );
};
